import { HTTPWithoutAuth } from "@/services/httpWithoutAuth";
import { HTTP } from "@/services/http";

export interface AuthTokens {
    access: string;
    refresh: string;
}

export interface PermissionResponse {
    permissionType: boolean;
    name: string;
    description: string;
    caption: string;
    options: [
        {
            description: string;
            value: string;
            position: number;
        },
    ];
}

export type DecodedJWTType = {
    token_type: "access" | "refresh";
    exp: number;
};

// TODO: tohle pujde do haje
export enum PrivilegesEnum {
  SUPERADMIN = "SUPERADMIN",
  DEVELOPER = "DEVELOPER",
  ADMIN = "ADMIN",
  DEALER = "DEALER",
  DEALER_ADMIN = "DEALER_ADMIN",
  USER = "USER",
  LOGIN = "LOGIN",
}

export default {
  async getMe() {
    return await HTTP.get<any>("/me/");
  },

  async getMyPermissions() {
    return (await HTTP.get<Array<PermissionResponse>>("/user-accounts/v1/permissions")).data;
  },

  async login(email: string, password: string) {
    return HTTPWithoutAuth.post<AuthTokens>("/auth/jwt/create/", {
      email: email,
      password: password,
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },

  async refreshAccessToken(refreshToken: string) {
    return HTTPWithoutAuth.post<AuthTokens>("/auth/jwt/refresh/", {
      refresh: refreshToken,
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return Promise.reject(error.message);
      });
  },
};
